import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import ComparePEORatesWrapper from "@components/layouts/comparepeoratesWrapper";

export default function ComparePEORatesHome(): ReactElement {
    return (
        <ComparePEORatesWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Compare PEO Rates"
                    domain="ComparePEORates.com"
                />
            </div>
        </ComparePEORatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
